export const STATUS = {
  RECEIVED: { label: "Ricevuto", cls: "bg-white text-slate-700 border-slate-400 border-dashed", color: "#cbd5e1" },
  TO_PLAN: { label: "Da pianificare", cls: "bg-slate-100 text-slate-700 border-slate-300", color: "#94a3b8" },
  PLANNED: { label: "Pianificato", cls: "bg-sky-50 text-sky-800 border-sky-300", color: "#0284c7" },
  IN_PROGRESS: { label: "In lavorazione", cls: "bg-amber-50 text-amber-800 border-amber-300", color: "#f59e0b" },
  SUSPENDED: { label: "Sospeso", cls: "bg-violet-50 text-violet-800 border-violet-300", color: "#8b5cf6" },
  COMPLETED: { label: "Completato", cls: "bg-teal-50 text-teal-800 border-teal-300", color: "#14b8a6" },
  TO_VALIDATE: { label: "Da validare", cls: "bg-orange-50 text-orange-800 border-orange-300", color: "#fb923c" },
  VALIDATED: { label: "Validato", cls: "bg-emerald-50 text-emerald-800 border-emerald-400", color: "#34d399" },
  BILLABLE: { label: "Contabilizzabile", cls: "bg-emerald-600 text-white border-emerald-600", color: "#059669" },
  CLOSED: { label: "Chiuso", cls: "bg-zinc-800 text-white border-zinc-800", color: "#27272a" },
  CANCELLED: { label: "Annullato", cls: "bg-zinc-100 text-zinc-500 border-zinc-300 line-through", color: "#d4d4d8" },
};

export const PRIORITY = {
  ORDINARIA: { label: "Ordinaria", cls: "text-slate-600 border-slate-300 bg-white" },
  URGENTE: { label: "Urgente", cls: "text-urgent border-urgent/50 bg-orange-50" },
  CRITICA: { label: "Critica", cls: "text-white border-urgent bg-urgent" },
};

export const SERVICE = { DELIVERY: "Delivery", ASSURANCE: "Assurance", CONSTRUCTION: "Construction" };
export const SERVICE_OPTIONS = Object.entries(SERVICE).map(([value, label]) => ({ value, label }));
export const ROLES = { admin: "Amministratore", direzione: "Direzione di gruppo", responsabile: "Responsabile operativo", assistente: "Assistente", tecnico: "Tecnico" };
export const SLOTS = { mattina: "Mattina", pomeriggio: "Pomeriggio", sera: "Sera" };
export const ABSENCE_TYPES = { FERIE: "Ferie", PERMESSO: "Permesso", MALATTIA: "Malattia", FORMAZIONE: "Formazione", ALTRO: "Altra assenza" };
export const ABSENCE_STATUS = { REQUESTED: ["In attesa", "bg-amber-100 text-amber-900"], APPROVED: ["Approvata", "bg-emerald-100 text-emerald-900"], REJECTED: ["Respinta", "bg-red-100 text-red-800"] };
export const SHIFT_KINDS = { MATTINA: "Mattina", POMERIGGIO: "Pomeriggio", SERA: "Sera", GIORNATA: "Giornata", REPERIBILITA: "Reperibilità", RIPOSO: "Riposo" };
export const PARTY_ROLES = { customer: "Committente / System Integrator", infrastructure_manager: "Gestore infrastruttura", supplier: "Fornitore" };

export const OUTCOMES = {
  DELIVERY: [{ value: "POSITIVE", label: "Positivo", cls: "POSITIVE" }, { value: "NEGATIVE", label: "Negativo (KO)", cls: "NEGATIVE" }, { value: "SUSPENDED", label: "Sospeso", cls: "SUSPENDED" }],
  ASSURANCE: [{ value: "RESTORED", label: "Ripristinato", cls: "POSITIVE" }, { value: "NOT_RESOLVED", label: "Non risolto", cls: "NEGATIVE" }, { value: "SUSPENDED", label: "Sospeso", cls: "SUSPENDED" }],
};
OUTCOMES.CONSTRUCTION = OUTCOMES.DELIVERY;
export const OUTCOME_LABEL = { POSITIVE: "Positivo", NEGATIVE: "Negativo (KO)", SUSPENDED: "Sospeso", RESTORED: "Ripristinato", NOT_RESOLVED: "Non risolto" };
export const CLASS_LABEL = { POSITIVE: "Positivo", NEGATIVE: "Negativo", SUSPENDED: "Sospeso" };

export const MEASURES = {
  DELIVERY: { potenza_ottica_dbm: "Potenza ottica (dBm)", test_velocita: "Test velocità / collaudo" },
  ASSURANCE: { misura_iniziale: "Misura iniziale", misura_finale: "Misura finale" },
  CONSTRUCTION: {},
};
export const MEASURE_LABEL = { ...MEASURES.DELIVERY, ...MEASURES.ASSURANCE, lunghezza_cavo_m: "Lunghezza cavo (m)" };
export const DETAIL_LABEL = {
  works_done: "Lavori eseguiti",
  ont_serial: "Seriale ONT / Modem", pto_installed: "PTO installata", port_used: "Porta utilizzata", fault_type: "Tipo di guasto",
  diagnosis: "Diagnosi", fault_point: "Punto di guasto", cause: "Causa", replaced_component: "Componente sostituito",
  repair: "Riparazione eseguita", final_tests: "Test conclusivi",
};

export function fmtDate(v) {
  if (!v) return "—";
  const d = new Date(v.length === 10 ? `${v}T00:00:00` : v);
  return d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function fmtDateTime(v) {
  if (!v) return "—";
  return new Date(v).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
}

export const fmtEuro = (n) => (n ?? 0).toLocaleString("it-IT", { style: "currency", currency: "EUR" });

export function addressLine(a = {}) {
  const parts = [a.street && `${a.street} ${a.number || ""}`.trim(), a.city && `${a.city}${a.province ? ` (${a.province})` : ""}`];
  return parts.filter(Boolean).join(", ") || "—";
}

export function addressExtra(a = {}) {
  return [a.staircase && `Scala ${a.staircase}`, a.floor && `Piano ${a.floor}`, a.apartment && `Int. ${a.apartment}`].filter(Boolean).join(" · ");
}

export function slaInfo(order) {
  if (!order?.sla_due_at || !["RECEIVED", "TO_PLAN", "PLANNED", "IN_PROGRESS", "SUSPENDED"].includes(order.status)) return null;
  const mins = Math.round((new Date(order.sla_due_at) - Date.now()) / 60000);
  const abs = Math.abs(mins);
  const txt = abs >= 60 ? `${Math.floor(abs / 60)}h ${abs % 60}m` : `${abs}m`;
  if (mins < 0) return { label: `Scaduto da ${txt}`, tone: "breach" };
  return { label: `${txt} rimanenti`, tone: mins < 240 ? "warn" : "ok" };
}

export function isoDate(d) {
  const z = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  return z.toISOString().slice(0, 10);
}
